














































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { RecommendationLetter } from '@/models/student/recommendation-letter';
import { recommendationLetterModule } from '@/store/modules/entities/recommendation-letter.module';

@Component({
  name: 'GStudentRecordRecommendationLetterModal',
})
export default class GStudentRecordRecommendationLetterModal extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ required: true }) letter!: RecommendationLetter;

  modalVisible = false;
  localTitle = '';
  localContent = '';
  originalTitle = '';
  originalContent = '';
  isReopening = false;
  tempTitle = '';
  tempContent = '';

  mounted() {
    if (this.value && this.letter) {
      this.initializeData();
    }
  }

  beforeDestroy() {
    // コンポーネント破棄時に確実にスクロールを復元
    document.body.style.overflow = '';
  }

  @Watch('value', { immediate: true })
  onValueChange(value: boolean) {
    this.modalVisible = value;
    if (value) {
      // モーダルが開く時に背景のスクロールを無効化
      document.body.style.overflow = 'hidden';
      this.$nextTick(() => {
        if (this.letter && !this.isReopening) {
          // 再度開く時以外は初期化
          this.initializeData();
        } else if (this.isReopening) {
          // 再度開く時は一時保存した編集内容を復元
          this.localTitle = this.tempTitle;
          this.localContent = this.tempContent;
        }
        // フラグをリセット
        this.isReopening = false;
      });
    } else {
      // モーダルが閉じる時に背景のスクロールを復元
      document.body.style.overflow = '';
      if (!this.isReopening) {
        // 再度開く予定でない場合のみリセット
        this.resetEditMode();
      }
    }
  }

  @Watch('letter', { immediate: true })
  onLetterChange(newLetter: RecommendationLetter) {
    if (this.value && newLetter) {
      this.initializeData();
    }
  }

  initializeData() {
    if (!this.letter) {
      return;
    }

    this.originalTitle = this.letter.title;
    this.originalContent = this.letter.content || '';
    this.localTitle = this.originalTitle;
    this.localContent = this.originalContent;
  }

  get hasChanges(): boolean {
    return this.localTitle !== this.originalTitle || this.localContent !== this.originalContent;
  }

  get isValidInput(): boolean {
    // タイトルが1文字以上かチェック（空白文字を除く）
    const isTitleValid = this.localTitle && this.localTitle.trim().length >= 1;

    // 本文が1文字以上かチェック（空白文字を除く）
    const isContentValid = this.localContent && this.localContent.trim().length >= 1;

    // タイトルと本文の両方が有効な場合のみtrue
    return isTitleValid && isContentValid;
  }

  get titleValidationError(): boolean {
    return !this.localTitle || this.localTitle.trim().length < 1;
  }

  get contentValidationError(): boolean {
    return !this.localContent || this.localContent.trim().length < 1;
  }

  get hasValidationErrors(): boolean {
    return !this.isValidInput;
  }

  cancelEdit() {
    if (this.hasChanges) {
      // 確認ダイアログ表示前に編集内容を一時保存（resetEditModeで消される前に）
      this.tempTitle = this.localTitle;
      this.tempContent = this.localContent;

      this.$Modal.confirm({
        title: this.$t('RECOMMENDATION_LETTER_UNSAVED_CHANGES').toString(),
        content: this.$t('RECOMMENDATION_LETTER_UNSAVED_CHANGES_CONTENT').toString(),
        okText: this.$t('DO_CANCEL').toString(),
        cancelText: this.$t('RETURN').toString(),
        onOk: () => {
          this.resetToOriginal();
          this.$emit('input', false); // 推薦書編集モーダルを閉じる
        },
        onCancel: () => {
          // 「戻る」ボタンが押された場合：編集内容を保持してモーダルを再度開く
          this.isReopening = true;
          this.$nextTick(() => {
            this.$emit('input', true);
          });
        },
      });
    } else {
      this.$emit('input', false); // 変更がない場合は通常通り閉じる
    }
  }

  resetToOriginal() {
    this.localTitle = this.originalTitle;
    this.localContent = this.originalContent;
  }

  resetEditMode() {
    this.resetToOriginal();
  }

  handleUpdate() {
    // 確認ダイアログ表示前に編集内容を一時保存（resetEditModeで消される前に）
    this.tempTitle = this.localTitle;
    this.tempContent = this.localContent;

    this.$Modal.confirm({
      title: this.$t('UPDATE_CONFIRMATION').toString(),
      content: this.$t('RECOMMENDATION_LETTER_UPDATE_CONFIRM').toString(),
      onOk: async () => {
        try {
          // 推薦書の更新処理
          await recommendationLetterModule.updateRecommendationLetter({
            id: this.letter.id,
            title: this.tempTitle,
            content: this.tempContent,
          });

          this.$Message.success(this.$t('RECOMMENDATION_LETTER_UPDATE_SUCCESS'));
          this.originalTitle = this.tempTitle;
          this.originalContent = this.tempContent;
          this.$emit('updated');
          this.$emit('input', false);
        } catch (error) {
          this.$Message.error(this.$t('RECOMMENDATION_LETTER_UPDATE_ERROR'));
        }
      },
      onCancel: () => {
        // 「キャンセル」ボタンが押された場合：モーダルを再度開く（事前保存された編集内容を使用）
        this.isReopening = true;
        this.$nextTick(() => {
          this.$emit('input', true);
        });
      },
    });
  }

  handleConfirm() {
    if (!this.isValidInput) {
      this.$Message.error(this.$t('PLEASE_ENTER_REQUIRED_FIELDS') || '必須項目を入力してください');
      return;
    }

    if (this.hasChanges) {
      this.handleUpdate();
    } else {
      // 変更がない場合は何もしない（ボタンは押せないはずだが念のため）
      this.$Message.warning(this.$t('NO_CHANGES_TO_SAVE') || '保存する変更がありません');
    }
  }

  handleCancel() {
    if (this.hasChanges) {
      this.cancelEdit();
    } else {
      this.$emit('input', false);
    }
  }
}
